module.exports = __webpack_public_path__ + "img/9788990220424.6ec09819.jpg";